var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSimple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M68.59 20.96c0-2.46-2-4.45-4.46-4.45H10.87c-2.46 0-4.46 2-4.46 4.45v33.08c0 2.46 2 4.45 4.46 4.45h53.26c2.46 0 4.46-2 4.46-4.45V20.96zm-24.6 16.48l23.25 19.7M8 57.39l23.12-19.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.01 17.5l25.37 21.9a6.36 6.36 0 008.27.03l25.59-21.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSimple);
export default __webpack_public_path__ + "static/media/email-simple.2a2dd21b13f40093b3bef959c2060fc4.svg";
export { ForwardRef as ReactComponent };